/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Division } from '../models/Division';
import type { LeagueList } from '../models/LeagueList';
import type { MatchLeague } from '../models/MatchLeague';
import type { MatchResultPatch } from '../models/MatchResultPatch';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DocumentParserService {
    /**
     * Get Division
     * @param query
     * @returns Division Successful Response
     * @throws ApiError
     */
    public static getDivisionDocumentParserDivisionGet(
        query: string,
    ): CancelablePromise<Division> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/document_parser/division',
            query: {
                'query': query,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Leagues Of Division
     * @param divisionId
     * @returns LeagueList Successful Response
     * @throws ApiError
     */
    public static getLeaguesOfDivisionDocumentParserLeaguesGet(
        divisionId: number,
    ): CancelablePromise<LeagueList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/document_parser/leagues',
            query: {
                'division_id': divisionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get League Match By Team Name And League And Match Day
     * @param leagueId
     * @param team1Name
     * @param team2Name
     * @param matchDay
     * @returns MatchLeague Successful Response
     * @throws ApiError
     */
    public static getLeagueMatchByTeamNameAndLeagueAndMatchDayDocumentParserMatchGet(
        leagueId: number,
        team1Name: string,
        team2Name: string,
        matchDay: number,
    ): CancelablePromise<MatchLeague> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/document_parser/match',
            query: {
                'league_id': leagueId,
                'team1_name': team1Name,
                'team2_name': team2Name,
                'match_day': matchDay,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Match League Result And Fix
     * @param matchId
     * @param requestBody
     * @returns MatchLeague Successful Response
     * @throws ApiError
     */
    public static patchMatchLeagueResultAndFixDocumentParserMatchResultMatchIdPatch(
        matchId: number,
        requestBody: MatchResultPatch,
    ): CancelablePromise<MatchLeague> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/document_parser/match_result/{match_id}',
            path: {
                'match_id': matchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
